import React from 'react';
import {OrbitSuspense} from '../../components/base-components/orbit-suspense/orbit-suspense';
import {IRoutingConfigurationService} from './routing-configuration.service.interface';
import {RoutingConfiguration} from './configuration/routing-configuration';
import {ServiceBase} from '../ServiceBase';
import {GamingHistoryType} from '../gaming-history/gaming-history-type';
import {MINI_ORBIT_ROUTING_DEFINITION} from '../../components/mini-orbit/routing/mini-orbit-routing-definition';
import {
  BLACKJACK_PAGE,
  CASINO_GAMES_PAGE, CHALLENGE_PAGE, EXCLUSIVE_888_GAMES_PAGE, GAMING_HISTORY_PAGE,
  HOME_PAGE, INSTANT_WIN_GAMES_PAGE,
  JACKPOTS_PAGE, NEW_GAMES_PAGE,
  NEW_LIVE_CASINO_PAGE,
  PROGRESSIVE_VIDEO_SLOTS_PAGE, ROULETTE_PAGE, SCRATCH_CARDS_PAGE, SESSION_HISTORY_PAGE,
  SLOTS_PAGE, VIDEO_POKER_PAGE, VIRTUAL_SPORTS_PAGE
} from '../../themes/css-global-classes';
import {
  BLACKJACK_ARENA_NAME,
  CASINO_GAMES_ARENA_NAME,
  EXCLUSIVE_ARENA_NAME, HOME_PAGE_ARENA, INSTANT_WIN_GAMES_ARENA_NAME, JACKPOTS_ARENA_NAME, NEW_GAMES_ARENA_NAME,
  NEW_LIVE_CASINO_ARENA_NAME, PROGRESSIVE_SLOTS_ARENA_NAME, ROULETTE_ARENA_NAME,
  SCRATCH_CARDS_ARENA_NAME,
  SLOTS_ARENA_NAME, VIDEO_POKER_ARENA_NAME, VIRTUAL_SPORT_ARENA_NAME
} from '../arenas/arena-consts';
import {CmsBannerComponent} from "../../components/cms-banner/cms-banner.component";

const ArenaHostComponent = React.lazy(
    () => import("../../components/arena-host/arena-host.component").then(({ArenaHostComponent}) => ({default: ArenaHostComponent}))
);

const CmsPageComponent = React.lazy(
    () => import('../../components/cms-page/cms-page.component').then(({CmsPageComponent}) => ({default: CmsPageComponent}))
);
const GamingHistoryPageComponent = React.lazy(
  () => import('../../components/gaming-history/gaming-history-page.component').then(({GamingHistoryPageComponent}) => ({default: GamingHistoryPageComponent}))
);
const RichPageComponent = React.lazy(
  () => import('../../components/rich-page/rich-page.component').then(({RichPageComponent}) => ({default: RichPageComponent}))
);
const LaboratoryShowcase = React.lazy(
  () => import('../../components/laboratory-showcase/laboratory-showcase.component').then(({LaboratoryShowcase}) => ({default: LaboratoryShowcase}))
);

export class RoutingConfigurationService extends ServiceBase implements IRoutingConfigurationService {
  getRoutingConfiguration(): RoutingConfiguration {
    return {
      fallbackRoute: {
        render: () => <OrbitSuspense><CmsPageComponent/></OrbitSuspense>
      },
      routes: [
        {
          paths: ['/'],
          exact: true,
          data: {arenaType: HOME_PAGE_ARENA},
          cssSelectors: HOME_PAGE,
          render: () =>
              <OrbitSuspense>
                <ArenaHostComponent />
              </OrbitSuspense>
        },
        {
          paths: ['/slots', '/video-slots', '/slot-machines', '/slot-machine', '/spillemaskiner', '/spelautomater', '/casino-games/online-slots', '/spielautomaten', '/gokkasten'],
          exact: true,
          data: {arenaType: SLOTS_ARENA_NAME},
          cssSelectors: SLOTS_PAGE,
          render: () =>
              <OrbitSuspense>
                <ArenaHostComponent />
              </OrbitSuspense>
        },
        {
          paths: ['/new-games', '/nieuwe-spellen'],
          exact: true,
          data: {arenaType: NEW_GAMES_ARENA_NAME},
          cssSelectors: NEW_GAMES_PAGE,
          render: () => <OrbitSuspense>
            <ArenaHostComponent />
          </OrbitSuspense>
        },
        {
          paths: ['/progressive-video-slots'],
          exact: true,
          data: {arenaType: PROGRESSIVE_SLOTS_ARENA_NAME},
          cssSelectors: PROGRESSIVE_VIDEO_SLOTS_PAGE,
          render: () => <OrbitSuspense>
            <ArenaHostComponent />
          </OrbitSuspense>
        },
        {
          paths: ['/casino-games/online-roulette', '/roulette', '/ruleta', '/roleta'],
          exact: true,
          data: {arenaType: ROULETTE_ARENA_NAME},
          cssSelectors: ROULETTE_PAGE,
          render: () => <OrbitSuspense>
            <ArenaHostComponent />
          </OrbitSuspense>
        },
        {
          paths: ['/virtual-sports'],
          exact: true,
          data: {arenaType: VIRTUAL_SPORT_ARENA_NAME},
          cssSelectors: VIRTUAL_SPORTS_PAGE,
          render: () => <OrbitSuspense>
            <ArenaHostComponent />
          </OrbitSuspense>
        },
        {
          paths: ['/casino-games/online-blackjack', '/blackjack'],
          exact: true,
          data: {arenaType: BLACKJACK_ARENA_NAME},
          cssSelectors: BLACKJACK_PAGE,
          render: () =><OrbitSuspense>
            <ArenaHostComponent />
          </OrbitSuspense>
        },
        {
          paths: ['/casino-games/jackpots', '/jackpots'],
          exact: true,
          data: {arenaType: JACKPOTS_ARENA_NAME},
          cssSelectors: JACKPOTS_PAGE,
          render: () => <OrbitSuspense>
            <ArenaHostComponent />
          </OrbitSuspense>
        },
        {
          paths: ['/casino-games/instant-win-games', '/instant-win-games'],
          exact: true,
          data: {arenaType: INSTANT_WIN_GAMES_ARENA_NAME},
          cssSelectors: INSTANT_WIN_GAMES_PAGE,
          render: () => <OrbitSuspense>
            <ArenaHostComponent />
          </OrbitSuspense>
        },
        {
          paths: ['/casino-games/all-games','/casino-games', '/jocuri-casino', '/jogos', '/card-table-games', '/juegos-de-casino', '/giochi-da-casino', '/casino-spil', '/casinospel', '/casino-spellen'],
          exact: true,
          data: {arenaType: CASINO_GAMES_ARENA_NAME},
          cssSelectors: CASINO_GAMES_PAGE,
          render: () => <OrbitSuspense>
            <ArenaHostComponent />
          </OrbitSuspense>
        },
        {
          paths: ['/gaming-history'],
          exact: true,
          cssSelectors: GAMING_HISTORY_PAGE,
          render: () => <OrbitSuspense key='gaming-history'>
            <GamingHistoryPageComponent key={GamingHistoryType.UserHistory} historyType={GamingHistoryType.UserHistory} redirectHomeIfUnauthorized={true} showMoreDetailsLink={true}/>
          </OrbitSuspense>
        },
        {
          paths: ['/session-history'],
          exact: true,
          cssSelectors: SESSION_HISTORY_PAGE,
          render: () => <OrbitSuspense key={'session-history'}>
            <GamingHistoryPageComponent key={GamingHistoryType.SessionHistory} historyType={GamingHistoryType.SessionHistory} redirectHomeIfUnauthorized={true} showMoreDetailsLink={false}/>
          </OrbitSuspense>
        },
        {
          paths: ['/challenge'],
          exact: true,
          cssSelectors: CHALLENGE_PAGE,
          render: () => <OrbitSuspense><RichPageComponent/></OrbitSuspense>
        },
        {
          paths: ['/live-casino', '/cazinou-live', '/ruleta-en-vivo'],
          exact: true,
          data: {arenaType: NEW_LIVE_CASINO_ARENA_NAME},
          cssSelectors: NEW_LIVE_CASINO_PAGE,
          render: () => <OrbitSuspense>
            <ArenaHostComponent />
          </OrbitSuspense>
        },
        {
          paths: ['/live-casino/new/'],
          exact: true,
          data: {arenaType: NEW_LIVE_CASINO_ARENA_NAME},
          cssSelectors: NEW_LIVE_CASINO_PAGE,
          render: () => <OrbitSuspense>
            <ArenaHostComponent />
          </OrbitSuspense>
        },
        {
          paths: ['/video-poker'],
          exact: true,
          data: {arenaType: VIDEO_POKER_ARENA_NAME},
          cssSelectors: VIDEO_POKER_PAGE,
          render: () => <OrbitSuspense>
            <ArenaHostComponent />
          </OrbitSuspense>
        },
        {
          paths: ['/scratch-cards', '/rubbelkarten'],
          exact: true,
          data: {arenaType: SCRATCH_CARDS_ARENA_NAME},
          cssSelectors: SCRATCH_CARDS_PAGE,
          render: () => <OrbitSuspense>
            <ArenaHostComponent />
          </OrbitSuspense>
        },
        {
          paths: ['/888-exclusive-games', '/888-exklusive-spiele', '/888-exclusieve-spellen'],
          exact: true,
          data: {arenaType: EXCLUSIVE_ARENA_NAME},
          cssSelectors: EXCLUSIVE_888_GAMES_PAGE,
          render: () => <OrbitSuspense>
            <ArenaHostComponent />
          </OrbitSuspense>
        },
        {
          paths: ["/gaming-history-standalone"],
          exact: true,
          cssSelectors: GAMING_HISTORY_PAGE,
          data: {standalone: true},
          render: () => <OrbitSuspense>
            <GamingHistoryPageComponent historyType={GamingHistoryType.UserHistory} showMoreDetailsLink={false} redirectHomeIfUnauthorized={false} />
          </OrbitSuspense>
        },
        {
          paths: ['/laboratory/'],
          exact: true,
          render: () => <OrbitSuspense><LaboratoryShowcase /></OrbitSuspense>
        },
        {
          paths: ['/banner-test/'],
          exact: true,
          render: () => (<OrbitSuspense>
                            <CmsBannerComponent key={'TEST_Banner'}
                                              showPlaceholder={true}
                                              componentID={509045}
                                              templateID={392012}
                                              fallbackComponent={null}/>
                        </OrbitSuspense>)
        },
        ...MINI_ORBIT_ROUTING_DEFINITION
      ]
    }
  }
}
